export default "__VITE_ASSET__VlDF_oz$__"